// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentSummary_container__17nZu","divider":"ContentSummary_divider__2veni","opaque":"ContentSummary_opaque__2BvH_","seeThrough":"ContentSummary_seeThrough__2ESbG"};